"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Gevorg Avetisyan on 12/8/2018.
 */
var EntitySearchModel = /** @class */ (function () {
    function EntitySearchModel(totalRowCount, data) {
        this._totalRowCount = totalRowCount;
        this._data = data;
    }
    Object.defineProperty(EntitySearchModel.prototype, "totalRowCount", {
        get: function () {
            return this._totalRowCount;
        },
        set: function (value) {
            this._totalRowCount = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntitySearchModel.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (value) {
            this._data = value;
        },
        enumerable: true,
        configurable: true
    });
    return EntitySearchModel;
}());
exports.EntitySearchModel = EntitySearchModel;
//# sourceMappingURL=entity-search.model.js.map